import { useState, useEffect } from "react";
import "../layout/layout.css";
import React from "react";
import _ from "lodash";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import httpService from "../../../services/http.service";
import "./slideshow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FaRegEdit } from "react-icons/fa";
import { FaRegTrashCan } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import FileUpload from "../file-upload/file-upload.component";
import secretutils from "../../../secretutils.json";
import DropboxChooser from "react-dropbox-chooser";
import GooglePicker from "react-google-picker";
import "react-toastify/dist/ReactToastify.css";
import useDrivePicker from "react-google-drive-picker";
import SuccessMessage from "../../common/successMsg";
import WarningMessage from "../../common/warnMsg";
import NasPop from "../NasSelectModalWindow/nasPop";
import ErrorMessage from "../../common/errorMsg";
var validUrl = require("valid-url");

let Slideshow = (props) => {
  const [openPicker, authResponse] = useDrivePicker();
  let NasUser = localStorage.getItem("UserId");
  const [selectedFiles, setSelectedFiles] = useState({});
  const [whichNasSelection, setWhichNasSelection] = useState("");
  const [files, setFiles] = useState([]);
  const [widgetList, setwidgetList] = useState([]);
  const [widgetLoading, setwidgetLoading] = useState(false);
  const [datarefresh, setdatarefresh] = useState(false);

  const [showPicker, setShowPicker] = useState(false);

  const [modalAddSlide, setmodalAddSlide] = useState(false);
  const [modaleditSlide, setmodaleditSlide] = useState(false);
  const [modalOneDrive, setmodalOneDrive] = useState(false);
  const [slideTitle, setSlideTitle] = useState("");
  const [slideabout, setslideabout] = useState("");
  const [slideshraeWebLink, setslideshraeWebLink] = useState("");
  const [slidetime, setslidetime] = useState(3);

  const [slidetype, setslidetype] = useState("");
  const [editIndex, seteditIndex] = useState(-1);
  const [addslideContent, setaddslideContent] = useState({});
  const [slideSharepicture, setslideSharePicture] = useState({
    Images: [],
  });

  const [previewSlide, setPreviewSlide] = useState(false);
  const [slidePreview, setSlidePreview] = useState("");
  const toggleOneDrive = () => setmodalOneDrive((prevState) => !prevState);

  const handleSelectFile = (fileName) => {
    setSelectedFiles((prevSelected) => ({
      ...prevSelected,
      [fileName]: !prevSelected[fileName],
    }));
  };

  const getNasFile = async (data) => {
    let res = await httpService
      .get(`/show-user-bucket-files?userID=${NasUser}`)
      .then((res) => res.data)
      .catch((err) => {
        ErrorMessage(err.response.data);
        return null;
      });
    if (data.format === "image") {
      const allImageFiles = res?.files.filter((item) => {
        console.log("Files : ", item)
        const fileSplit = item.name.split(".")[1].toLowerCase();
        return data.type.includes(fileSplit);
      });
      if (allImageFiles.length === 0) {
        WarningMessage("There is no image file. Please upload it first.");
        return
      }
      setFiles(allImageFiles);
    }
  };

  const handleOpenPicker4Slide = (value) => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp"],
      format: "image",
    };
    if (value === "add") {
      getNasFile(data);
      setWhichNasSelection("addslide");
    } else {
      getNasFile(data);
      setWhichNasSelection("editslide");
    }

    // toggleSlideShare()
  };

  const handleNASSubmit = () => {
    console.log(104, selectedFiles)
    const selected = Object.keys(selectedFiles).filter(
      (fileName) => selectedFiles[fileName]
    );
    console.log("Selected files:", selected);

    if (whichNasSelection === "addslide") {
      // handleSubmitBgPicture(selected[0], "backgroundimage")
      if (Array.isArray(selected) && selected.length > 0) {
        selected.forEach((filePath) => {
          if (typeof filePath === "string") {
            let nameParts = filePath.split("/");
            console.log("nameParts : ", nameParts)
            let fileName =
              nameParts.length > 0 ? nameParts[nameParts.length - 1] : "";
            if (fileName) {
              handleSubmitPictureSlideshare(filePath, fileName);
            } else {
              console.error(
                `File name could not be determined from the path: ${filePath}`
              );
            }
          } else {
            console.error(`Invalid file path: ${filePath}`);
          }
        });
        SuccessMessage("Slide Added");
      } else {
        console.error("No valid files selected");
      }
    } else if (whichNasSelection === "editslide") {
      // selected.map((file, index) => {
      let name = selected[0]?.split("/");
      let len = name?.length;
      editSlideSlidsharePhoto(selected[0], name[len - 1]);

      // let array = [...audioArray];
      // array.push({ link: `${window.location.origin}/api/v1/nas/download?path=`+file, name:name[len-1] });
      // setaudioArray(array);

      // })
    } else if (whichNasSelection === "picture") {
      // selected.map((file,index)=>{
      let name = selected[0]?.split("/");
      let len = name?.length;
      // handleSubmitPicture(selected[0],name[len-1])
    } else {
      // createSliderUsingNAS(selected)
    }
    setShowPicker(false);
    setWhichNasSelection("");
    setSelectedFiles({});
    setmodaleditSlide(false);
  };

  useEffect(() => {
    if (files.length > 0) {
      setShowPicker(true);
    } else {
      setShowPicker(false);
    }
  }, [files]);

  const toggleAddSlide = () =>
    setmodalAddSlide((prevState) => {
      if (prevState === true) {
        setslideshraeWebLink("");
        setslideSharePicture({
          Images: [],
        });
        setSlideTitle("");
        setslideabout("");
        setaddslideContent({});
        setslidetype("");
        setslidetime(3);
      }
      return !prevState;
    });
  const toggleeditSlide = () =>
    setmodaleditSlide((prevState) => {
      if (prevState === true) {
        setslideshraeWebLink("");
        setslideSharePicture({
          Images: [],
        });
        setSlideTitle("");
        setslideabout("");
        setaddslideContent({});
        setslidetype("");
        setslidetime(3);
      }
      return !prevState;
    });

  const toggleData = () => setdatarefresh((prevState) => !prevState);

  useEffect(async () => {
    let dataPost = {
      layout_id: props.selectedLayoutID,
    };
    let widgetdata = await httpService
      .CreateUpdate("getwidgetsApi", dataPost)
      .catch((err) => {
        return;
      });
    setwidgetList(props.widgetList);
    setwidgetLoading(true);
  }, []);

  useEffect(() => { }, [widgetLoading]);

  useEffect(() => {
    // getWidgets();
  }, [datarefresh]);

  const oneDriveFilePicker = () => {
    toggleOneDrive();
  };
  const getAuthenticationToken = () => {
    return Promise.resolve(
      "EwCYA8l6BAAUwihrrCrmQ4wuIJX5mbj7rQla6TUAAbtqHdRksO36h6sKq+oqEaMinsfZuefV3kkfpKgLnUc3Drnhy8ogTqxinG8nE7kSZZamS+EVGfEr0hx1tfBv1C4Qyex5PAA6sIv63eZCRtcC76mMCccP6vzTWZmDISOtOZjcw5eJJfvwH3yDP97rjwJWnonhkmCqGaGrObeqHf1uz5H6hkGGTwS2u4QwDSFopceaVs8QSA6kXhFvt9ciYFCDEwkxRUolXEkm2+X7hwq13cX9UzYzg7BUErsfce9Amb6w92qLGYgnGu6jQqZK+jLZvNkzaa7eHf8jw43p9QfBC8W6BODS1D0FKLcugJ37MWYG6wYETFll0A4sGMv2hywDZgAACK1UtgDjzFsWaAJyNkl9juKLktKmmqPKry3+mY9QYG+2z3am6b7uDS1kqqrEFtFWFFkYyF7xvmGoRrDGnWMuH6OU995UClA/Bl6IkUZOB72N8HqNsry7fZv5aXjehJ+n325XMc09YcQRltowxQkt7nG5Bg7Zn/NW5PVZi2YECFeSW8IRvMn18qcjnZ0LOV+xOUCbaDD4kTVovowK02E7W2YoSsT6ataZt/Ds1C3lDEqNoTDrZ8Th7fe0mP6VcszQPz371Asnu1ZKEPvUKW89XOp/ieg0USIh9qUaBAM00XEfjAiR+KfktxZVP1nGFyJJljywcwC9TaeV++0r5MTHAeidkGAdITihm9kU/sVfiwOP/KXnXnsE0urgbN9t66CspFVe5SmAHicvuEf2TVW74LUDmc90OcriHfgMJplrXRWJl/bOhvozU/ZLLr9M3qCLV9A13EcDOWzfpwT5gYPopzfeekaFKfo3bdmsmlvT2T4nOuW5EO3Ixo5VOQL5eiDATWZ6fUhGzTXPFG+Q383ORPLhR0vMvNNIL6OSw30EK/bilE25osgPGgAJE0oE1ZJ+xbMgpm5Y0z4admK6GZ6b4EhMzVuxeVEcW+Z2lU5mEsSH/E/u1nc1bcnoe1xOGV7SA8tS5uYxsbQ9FV4+ZrkPRNoLuwp+8rzRKDXqkUjSn2EhnmXjCEijZ6/UAb9pFPmZntgamWpL0USDuswagzQyfonCDs4wbyqbA47IfCe+TTZ4WurKOtyIPPfTPKdgSUDrr4hCaTZ4iVp5P2o1vFkC4BWnwtHjxZdbOlTh6W+NxjNm/cV84fRIR3xzuCAQyM2N0Ga3rwI="
    );
  };
  const onSuccess = (keys) => {
    console.log("onSuccess", keys);
  };
  const onSubmit = (e) => {
    e.preventdefault();
  };
  const handleSubmitPictureSlideshare = async (url, name) => {

    console.log("Handle Submit Pictures Slideshare : ", name)
    let dataarray = addslideContent.content;
    dataarray.push([url, "image", name, slideTitle, slideabout, slidetime]);
    let data = {
      type: "slideshare",
      id: addslideContent._id,
      content: dataarray,
    };
    // let widgetdata = await httpService
    //   .CreateUpdate("addslidetoslideshowApi", data)
    //   .catch((err) => {
    //     console.log(err);
    //   });
    for (let i = 0; i < props.widgetList.length; i++) {
      if (data.id === props.widgetList[i]._id) {
        let widgetlistData = [...props.widgetList];
        widgetlistData[i].type = data.type;
        widgetlistData[i].content = data.content;
        props.setwidgetList(() => {
          return widgetlistData;
        });
        let editwidgetlistData = [...props.editWidgeContent];
        editwidgetlistData.push(data);

        props.seteditWidgeContent(() => {
          return editwidgetlistData;
        });
      }
    }
    setslideshraeWebLink("");
    setslideSharePicture({
      Images: [],
    });
    setSlideTitle("");
    setslideabout("");
    setaddslideContent({});
    toggleAddSlide();
    setmodalAddSlide(false);
    // props.toggleSlideshare();
  };

  const AddtoSlideshare = async () => {
    let dataarray = addslideContent.content;
    {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (slideshraeWebLink.match(p)) {
      } else {
        WarningMessage("Please Enter the Valid YouTube URL");
        return;
      }
    }
    if (slideshraeWebLink != "") {
      dataarray.push([
        slideshraeWebLink,
        "weblink",
        slideTitle,
        slideabout,
        slidetime,
      ]);
    }

    let data = {
      type: "slideshare",
      id: addslideContent._id,
      content: dataarray,
    };
    // let widgetdata = await httpService
    //   .CreateUpdate("addslidetoslideshowApi", data).then(res=>res.data)
    //   .catch((err) => {
    //     console.log(err);
    //   });
    for (let i = 0; i < props.widgetList.length; i++) {
      if (data.id === props.widgetList[i]._id) {
        let widgetlistData = [...props.widgetList];
        widgetlistData[i].type = data.type;
        widgetlistData[i].content = data.content;
        props.setwidgetList(() => {
          return widgetlistData;
        });
        let editwidgetlistData = [...props.editWidgeContent];
        editwidgetlistData.push(data);

        props.seteditWidgeContent(() => {
          return editwidgetlistData;
        });
      }
    }
    // if(widgetdata.message === 'Successful'){
    SuccessMessage("Slide Added ");
    // }
    setslideshraeWebLink("");
    setslideSharePicture({ Images: [] });
    setSlideTitle("");
    setslideabout("");
    setaddslideContent({});
    toggleAddSlide();
    setmodalAddSlide(false);
    props.toggleSlideshare();
    return;
  };

  const getId = (url) => {
    const regExp =
      /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&]{10,12})/;
    const match = url.match(regExp);
    return match[1];
  };

  const editSlideshoecontent = (id, index, edit) => {
    let array = [...edit.content];
    let dataArray = array[index];
    seteditIndex(index);
    if (dataArray[1] === "image") {
      setSlideTitle(dataArray[3]);
      setslideabout(dataArray[4]);
      setslidetime(dataArray[5]);
      setslidetype("image");
      setslideSharePicture({
        Images: [],
      });
    } else {
      setSlideTitle(dataArray[2]);
      setslideabout(dataArray[3]);
      setslideshraeWebLink(dataArray[0]);
      setslidetime(dataArray[4]);
      setslidetype("weblink");
    }
    toggleeditSlide();
  };
  const updateSlide = async (e) => {
    let dataarray = [];
    if (slidetype === "weblink") {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (!slideshraeWebLink.match(p)) {
        WarningMessage("Please Enter the Valid YouTube URL");
        return;
      }
      dataarray = addslideContent.content;
      if (slidetype === "weblink") {
        dataarray[editIndex] = [
          slideshraeWebLink,
          "weblink",
          slideTitle,
          slideabout,
          slidetime,
        ];
      }
    } else {
      dataarray = addslideContent.content;
      // alert(addslideContent)
      console.log(addslideContent, "addslideContent");
      dataarray[editIndex] = [
        dataarray[editIndex][0],
        "image",
        dataarray[editIndex][2],
        slideTitle,
        slideabout,
        slidetime,
      ];
    }

    // if(slidetype == "image"){
    //     await getBase64(slideSharepicture.Images[0])
    //       .then(result => {
    //         baseImage = result;
    //         console.log("File Is", baseImage);
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //       dataarray[editIndex]  =[baseImage,"image", slideSharepicture.Images[0].name, slideTitle, slideabout, slidetime];
    //       baseImage = "";
    // }
    let data = {
      type: "slideshare",
      id: addslideContent._id,
      content: dataarray,
    };
    // let widgetdata = await httpService
    //   .CreateUpdate("addslidetoslideshowApi", data)
    //   .catch((err) => {
    //     console.log(err);
    //   });
    for (let i = 0; i < props.widgetList.length; i++) {
      if (data.id === props.widgetList[i]._id) {
        let widgetlistData = [...props.widgetList];
        widgetlistData[i].type = data.type;
        widgetlistData[i].content = data.content;
        props.setwidgetList(() => {
          return widgetlistData;
        });
        let editwidgetlistData = [...props.editWidgeContent];
        editwidgetlistData.push(data);

        props.seteditWidgeContent(() => {
          return editwidgetlistData;
        });
      }
    }
    SuccessMessage("Slide Modified");
    setslideshraeWebLink("");
    setslideSharePicture({
      Images: [],
    });
    setSlideTitle("");
    setslideabout("");
    setslidetime(3);
    setaddslideContent({});
    toggleeditSlide();
  };
  const editSlideSlidsharePhoto = async (url, name) => {
    let dataarray = addslideContent.content;
    dataarray[editIndex] = [
      url,
      "image",
      name,
      slideTitle,
      slideabout,
      slidetime,
    ];
    let data = {
      type: "slideshare",
      id: addslideContent._id,
      content: dataarray,
    };
    // let widgetdata = await httpService
    //   .CreateUpdate("addslidetoslideshowApi", data)
    //   .catch((err) => {
    //     console.log(err);
    //   });
    for (let i = 0; i < props.widgetList.length; i++) {
      if (data.id === props.widgetList[i]._id) {
        let widgetlistData = [...props.widgetList];
        widgetlistData[i].type = data.type;
        widgetlistData[i].content = data.content;
        props.setwidgetList(() => {
          return widgetlistData;
        });
        let editwidgetlistData = [...props.editWidgeContent];
        editwidgetlistData.push(data);

        props.seteditWidgeContent(() => {
          return editwidgetlistData;
        });
      }
    }
    SuccessMessage("Slide Modified");
    setslideshraeWebLink("");
    setslideSharePicture({ Images: [] });
    setSlideTitle("");
    setslideabout("");
    setslidetime(3);
    setaddslideContent({});
    // props.toggleSlideshare();
  };
  const removeSlideshoecontent = async (id, index, edit) => {
    let array = [...edit.content];
    array.splice(index, 1);
    let data = {
      id: id,
      type: "slideshare",
      content: array,
    };
    // let widgetdata = await httpService
    //   .CreateUpdate("removeslideAPI", data)
    //   .catch((err) => {
    //     console.log(err);
    //   });
    for (let i = 0; i < props.widgetList.length; i++) {
      if (data.id === props.widgetList[i]._id) {
        let widgetlistData = [...props.widgetList];
        widgetlistData[i].type = data.type;
        widgetlistData[i].content = data.content;
        props.setwidgetList(() => {
          return widgetlistData;
        });
        let editwidgetlistData = [...props.editWidgeContent];
        editwidgetlistData.push(data);
        props.seteditWidgeContent(() => {
          return editwidgetlistData;
        });
      }
    }
    // if (widgetdata.data.message == "Successful") {
    toggleData();
    SuccessMessage("Slide Deleted");
    // }
  };
  const getpictureurl = (url) => {
    let finalUrl = "";
    let urlreturn = "";
    if (url.includes("drive.google")) {
      finalUrl = url.substring(
        url.indexOf("/file/d/") + 8,
        url.indexOf("/view")
      );
      urlreturn = "https://drive.google.com/thumbnail?id=" + finalUrl;
      // urlreturn = "https://drive.google.com/uc?export=view&id=" + finalUrl;
    } else if (url.includes("dropbox.com")) {
      urlreturn = url.replace("dl=0", "raw=1");
    } else if (!url.includes(`/api/v1/gcp-asset-file?userID=`)) {
      urlreturn = `${window.location.origin}/api/v1/gcp-asset-file?userId=${NasUser}&filePath=${url}`;


      if (window.location.href.includes('/view/')) {
        urlreturn = `${window.location.origin}/api/v1/gcp-asset-file?filePath=${url}&billbordid=${window.location.href.split("/view/")[1].split("/")[0]}`;
      }


    }

    return urlreturn;
  };
  const handleOpenPicker = () => {
    try {
      openPicker({
        clientId: props.driveClientid,
        developerKey: props.drivekey,
        viewId: "DOCS",
        // token: token, // pass oauth token in case you already have one
        showUploadView: true,
        showUploadFolders: true,
        supportDrives: true,
        multiselect: true,
        // viewMimeTypes: ['image/jpeg', 'image/png'],
        viewMimeTypes: "image/jpeg,image/png",

        // customViews: customViewsArray, // custom view
        callbackFunction: (data) => {
          if (data.action === "cancel") {
            console.log("User clicked cancel/close button");
          }
          if (data.docs) {
            data.docs.map((i) => {
              handleSubmitPictureSlideshare(i.url, i.name);
            });
          }
        },
      });
    } catch (e) {
      console.log("problem in : " + e);
    }
  };
  const handleOpenPicker2 = () => {
    try {
      openPicker({
        clientId: props.driveClientid,
        developerKey: props.drivekey,
        viewId: "DOCS",
        // token: token, // pass oauth token in case you already have one
        showUploadView: true,
        showUploadFolders: true,
        supportDrives: true,
        multiselect: true,
        // viewMimeTypes: ['image/jpeg', 'image/png'],
        viewMimeTypes: "image/jpeg,image/png",
        // customViews: customViewsArray, // custom view
        callbackFunction: (data) => {
          if (data.action === "cancel") {
            console.log("User clicked cancel/close button");
          }
          if (data.docs) {
            data.docs.map((i) => {
              editSlideSlidsharePhoto(i.url, i.name);
            });
          }
        },
      });
    } catch (e) {
      console.log("problem in 1 : " + e);
    }
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    props.setwidgetList((prevList) =>
      prevList.map((widget) => {
        if (widget._id === props.widgetId) {
          const items = [...widget.content];
          const [reorderedItem] = items.splice(source.index, 1);
          items.splice(destination.index, 0, reorderedItem);

          // Update widget list properly
          const updatedWidgetList = prevList.map((w) =>
            w._id === widget._id ? { ...w, content: items } : w
          );

          props.setwidgetList(updatedWidgetList);

          // Find the widget to update
          const widgetToUpdate = updatedWidgetList.find(
            (w) => w._id === props.widgetId
          );

          if (widgetToUpdate) {
            // Create a new object with updated content
            const editwidgetlistData = {
              type: widgetToUpdate.type,
              id: widgetToUpdate._id,
              content: widgetToUpdate.content,
            };

            // Update editWidgeContent
            props.seteditWidgeContent((prevEditContent) => [
              ...prevEditContent,
              editwidgetlistData,
            ]);
          }

          return { ...widget, content: items };
        }
        return widget;
      })
    );
  };

  return (
    <div>
      <DragDropContext onDragEnd={handleDragEnd}>
        {widgetLoading &&
          props.widgetList.map((e, i) => {
            return (
              <div>
                {(e.type === "slideshare" || e.type === "initialSlideshare") &&
                  e._id === props.widgetId ? (
                  <div
                    classname="slideheadingmain"
                    style={{ overflow: "hidden" }}
                  >
                    <div className="slideheading">
                      <div className="slideheadingtitle">Slideshow</div>
                      <Button
                        color="primary"
                        type="submit"
                        className=" Addslidebutton"
                        onClick={() => {
                          toggleAddSlide();
                          setaddslideContent(e);
                        }}
                      >
                        <b>+</b> Add a Slide
                      </Button>
                      {e.type === "initialSlideshare" ? (
                        <div hidden>{(e.content = [])}</div>
                      ) : (
                        <div hidden></div>
                      )}
                      <Droppable droppableId="slides">
                        {(provided) => (
                          <div
                            className="slidesHeading"
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {e.content.map((item, index) => {
                              console.log("ITEM : ", item[0])
                              return (
                                <Draggable
                                  key={index}
                                  draggableId={String(index)}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      className=""
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      {item[1] === "image" ? (
                                        <div
                                          className={`slider-tab ${snapshot.draggingOver
                                            ? "dragcomplete"
                                            : ""
                                            }`}
                                        >
                                          <div
                                            style={{
                                              height: 85,
                                              width: 90,
                                              position: "relative",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              setPreviewSlide(true);
                                              setSlidePreview(
                                                getpictureurl(item[0])
                                              );
                                            }}
                                          >
                                            <img
                                              className="pictureslide"
                                              style={{
                                                height: "100%",
                                                width: "100%",
                                                objectFit: "cover",
                                              }}
                                              src={getpictureurl(item[0])}
                                              alt="image"
                                            />
                                            <div
                                              style={{
                                                height: 20,
                                                width: "100%",
                                                backgroundColor: "black",
                                                position: "absolute",
                                                left: 10,
                                                bottom: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0px 2px",
                                                gap: 5,
                                              }}
                                              onClick={() => {
                                                setPreviewSlide(true);
                                                setSlidePreview(
                                                  getpictureurl(item[0])
                                                );
                                              }}
                                            >
                                              <FaEye color="white" />
                                              <p style={{ color: "white" }}>
                                                Preview
                                              </p>
                                            </div>
                                          </div>
                                          <div className="pictureslidename">
                                            <b>{item[3]}</b>
                                          </div>

                                          <div
                                            style={{ display: "flex", gap: 5 }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "blue",
                                                color: "white",
                                                height: 55,
                                                width: 55,
                                                cursor: "pointer",
                                                borderRadius: 6,
                                              }}
                                              className=""
                                              onClick={() => {
                                                setaddslideContent(e);
                                                editSlideshoecontent(
                                                  e._id,
                                                  index,
                                                  e
                                                );
                                              }}
                                            >
                                              <FaRegEdit size={20} />
                                            </div>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: "red",
                                                color: "white",
                                                height: 55,
                                                width: 55,
                                                cursor: "pointer",
                                                borderRadius: 6,
                                              }}
                                              className=""
                                              onClick={() =>
                                                removeSlideshoecontent(
                                                  e._id,
                                                  index,
                                                  e
                                                )
                                              }
                                            >
                                              <FaRegTrashCan size={20} />
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="row">
                                          <div className="col-10">
                                            <img
                                              className="pictureslide"
                                              width="50"
                                              height="50"
                                              src={
                                                "http://img.youtube.com/vi/" +
                                                getId(item[0]) +
                                                "/0"
                                              }
                                              alt="image"
                                            />{" "}
                                            <div className="pictureslidename">
                                              {" "}
                                              <b>{item[2]}</b> {"  "} {"("}{" "}
                                              {item[0]} {")"}
                                            </div>
                                          </div>
                                          <Button
                                            color="primary"
                                            className="col-1 SlideButton"
                                            onClick={() => {
                                              setaddslideContent(e);
                                              editSlideshoecontent(
                                                e._id,
                                                index,
                                                e
                                              );
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              className="icon"
                                              icon={faEdit}
                                            />
                                          </Button>
                                          <Button
                                            color="danger"
                                            className="col-1 SlideButton"
                                            onClick={() =>
                                              removeSlideshoecontent(
                                                e._id,
                                                index,
                                                e
                                              )
                                            }
                                          >
                                            <FontAwesomeIcon
                                              className="icon"
                                              icon={faTrash}
                                            />
                                          </Button>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            );
          })}
      </DragDropContext>

      <Modal isOpen={modalAddSlide} toggle={toggleAddSlide}>
        <ModalHeader toggle={toggleAddSlide}>Add a new Slide</ModalHeader>
        <ModalBody>
          <div>
            <form className="slidesharemainform">
              {/*<b>Enter the Title of Slide</b>
              <input
                type="text" 
                className="form-control slideshowTitle"
                value={slideTitle}
                onChange={(e) => setSlideTitle(e.target.value)}
              ></input>
              <b>Enter something about the Slide</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={slideabout}
                onChange={(e) => setslideabout(e.target.value)}
              ></input>*/}
              <b>Enter Timeframe of the Slide (in sec)</b>
              <input
                type="number"
                className="form-control slideshowTitle"
                value={slidetime}
                onChange={(e) => setslidetime(e.target.value)}
              ></input>
              <b>Select the Picture to upload</b>
              <div className="row">
                <div className="col-6 selectButton">
                  <DropboxChooser
                    appKey={props.dropboxkey}
                    success={async (files) => {
                      await files.map((i) => {
                        handleSubmitPictureSlideshare(i.link, i.name);
                      });
                    }}
                    cancel={() => console.log("closed")}
                    multiselect={true}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={(event) => {
                        event.preventDefault();
                        // props.toggleSlideshare();
                      }}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from dropbox</div>
                      </div>
                    </Button>
                  </DropboxChooser>
                </div>
                <div className="col-6 selectButton">
                  <Button
                    disabled={props.naslicence}
                    className="form-control"
                    color="primary"
                    onClick={() => {
                      handleOpenPicker4Slide("add");
                    }}
                  >
                    <div className="row">
                      <div className="col-9">Cloud Storage</div>
                    </div>
                  </Button>
                  {/*<GooglePicker
                    clientId={props.driveClientid}
                    developerKey={props.drivekey}
                    scope={["https://www.googleapis.com/auth/drive.readonly"]}
                    onChange={async (data) => {
                      if (data.docs) {
                        console.log("on change:", data.docs);
                        data.docs.map((i) => {
                          handleSubmitPictureSlideshare(i.url, i.name);
                        });
                      }
                    }}
                    onAuthFailed={(data) =>
                      console.log("on auth failed:", data)
                    }
                    multiselect={false}
                    navHidden={true}
                    authImmediate={false}
                    mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
                    viewId={"DOCS"}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={(event) => {
                        event.preventDefault();
                        setmodalAddSlide(false);
                        // props.toggleSlideshare();
                      }}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from Drive</div>
                      </div>
                    </Button>
                    </GooglePicker>*/}
                  {/* <Button
                    className="form-control"
                    color="primary"
                    onClick={(event) => {
                      event.preventDefault();
                      setmodalAddSlide(false);
                      handleOpenPicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from Drive</div>
                    </div>
                  </Button> */}
                </div>
                <div className="col-3 selectButton"></div>
                {/* <div className="col-6 selectButton">
                  <Button
                    color="primary"
                    className="form-control"
                    onClick={() => {
                      oneDriveFilePicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from OneDrive</div>
                    </div>
                  </Button>
                </div> */}
              </div>
              <div className="orcenter"> OR </div>
              <b>Enter the url of youtube video</b>
              <input
                type="url"
                className="form-control websiteLink"
                value={slideshraeWebLink}
                onChange={(e) => setslideshraeWebLink(e.target.value)}
              ></input>
              {/*<button type="submit">Create New User</button>*/}
              <Button
                color="primary"
                className="form-control"
                onClick={AddtoSlideshare}
              >
                Add to Slideshare
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalOneDrive} toggle={toggleOneDrive}>
        <ModalHeader toggle={toggleOneDrive}>OneDrive Picker</ModalHeader>
        <ModalBody>
          <div>
            {/* <GraphFileBrowser
              getAuthenticationToken={getAuthenticationToken}
              onSuccess={onSuccess}
            /> */}
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modaleditSlide} toggle={toggleeditSlide}>
        <ModalHeader toggle={toggleeditSlide}>Edit Slide</ModalHeader>
        <ModalBody>
          <div>
            <form className="slidesharemainform">
              {/*<b>Edit the Title of Slide</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={slideTitle}
                onChange={(e) => setSlideTitle(e.target.value)}
              ></input>
              <b>Edit about section of the Slide</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={slideabout}
                onChange={(e) => setslideabout(e.target.value)}
              ></input>*/}
              <b>Enter Timeframe of the Slide (in sec)</b>
              <input
                type="number"
                className="form-control slideshowTitle"
                value={slidetime}
                onChange={(e) => setslidetime(e.target.value)}
              ></input>
              {slidetype === "weblink" ? (
                <div>
                  <b>Edit the url of youtube video</b>
                  <input
                    type="url"
                    className="form-control websiteLink"
                    value={slideshraeWebLink}
                    onChange={(e) => setslideshraeWebLink(e.target.value)}
                  ></input>
                </div>
              ) : (
                <div>
                  <b>Select the Picture to replace</b>
                  <div className="row">
                    <div className="col-6 selectButton">
                      <DropboxChooser
                        appKey={props.dropboxkey}
                        success={async (files) => {
                          await files.map((i) => {
                            editSlideSlidsharePhoto(i.link, i.name);
                          });
                        }}
                        cancel={() => console.log("closed")}
                        multiselect={true}
                      >
                        <Button
                          className="form-control"
                          color="primary"
                          onClick={(event) => {
                            event.preventDefault();
                            setmodaleditSlide(false);
                            // props.toggleSlideshare();
                          }}
                        >
                          <div className="row">
                            <div className="col-3">
                              <FontAwesomeIcon
                                className="icon"
                                icon={faImages}
                              />
                            </div>
                            <div className="col-9">Select from dropbox</div>
                          </div>
                        </Button>
                      </DropboxChooser>
                    </div>
                    <div className="col-6 selectButton">
                      <Button
                        className="form-control"
                        color="primary"
                        onClick={() => {
                          handleOpenPicker4Slide("edit");
                        }}
                      >
                        <div className="row">
                          <div className="col-9">Cloud Storage</div>
                        </div>
                      </Button>
                      {/*<GooglePicker
                        clientId={props.driveClientid}
                        developerKey={props.drivekey}
                        scope={[
                          "https://www.googleapis.com/auth/drive.readonly",
                        ]}
                        onChange={async (data) => {
                          if (data.docs) {
                            console.log("on change:", data.docs);
                            data.docs.map((i) => {
                              editSlideSlidsharePhoto(i.url, i.name);
                            });
                          }
                        }}
                        onAuthFailed={(data) =>
                          console.log("on auth failed:", data)
                        }
                        multiselect={false}
                        navHidden={true}
                        authImmediate={false}
                        mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
                        viewId={"DOCS"}
                      >
                        <Button
                          className="form-control"
                          color="primary"
                          onClick={(event) => {
                            event.preventDefault();
                            setmodaleditSlide(false);
                            // props.toggleSlideshare();
                          }}
                        >
                          <div className="row">
                            <div className="col-3">
                              <FontAwesomeIcon
                                className="icon"
                                icon={faImages}
                              />
                            </div>
                            <div className="col-9">Select from Drive</div>
                          </div>
                        </Button>
                        </GooglePicker>*/}
                      {/* <Button
                        className="form-control"
                        color="primary"
                        onClick={(event) => {
                          event.preventDefault();
                          setmodaleditSlide(false);
                          handleOpenPicker2();
                        }}
                      >
                        <div className="row">
                          <div className="col-3">
                            <FontAwesomeIcon
                              className="icon"
                              icon={faImages}
                            />
                          </div>
                          <div className="col-9">Select from Drive</div>
                        </div>
                      </Button> */}
                    </div>
                    <div className="col-3 selectButton"></div>
                    {/* <div className="col-6 selectButton">
                      <Button
                        color="primary"
                        className="form-control"
                        onClick={() => {
                          oneDriveFilePicker();
                        }}
                      >
                        <div className="row">
                          <div className="col-3">
                            <FontAwesomeIcon className="icon" icon={faImages} />
                          </div>
                          <div className="col-9">Select from OneDrive</div>
                        </div>
                      </Button>
                    </div> */}
                  </div>
                </div>
              )}
              <Button
                color="primary"
                className="form-control"
                onClick={updateSlide}
              >
                Save Slide
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        className="modal-xl h-60%"
        isOpen={previewSlide}
        toggle={() => setPreviewSlide(false)}
      >
        <ModalHeader toggle={() => setPreviewSlide(false)}>
          Slideshow Image Preview
        </ModalHeader>
        <div style={{ height: "75vh", padding: 10 }}>
          <img
            style={{
              height: "100%",
              width: "100%",
              objectFit: "contain",
            }}
            src={slidePreview}
          />
        </div>
      </Modal>
      <NasPop
        showPicker={showPicker}
        files={files}
        selectedFiles={selectedFiles}
        handleSelectFile={handleSelectFile}
        handleNASSubmit={handleNASSubmit}
        setShowPicker={setShowPicker}
      />

      <style jsx>{`
        .file-picker {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .popup {
          background-color: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default Slideshow;
